import useRolesModel from "./rolesPageModel";
import RoleList from "./_cmp/RoleList";
import RoleListSkeleton from "./_cmp/RoleListSkeleton";
import RolesToolbar from "./_cmp/RolesToolbar";
import { RoleDialog } from "./_cmp/roleForm/RoleDialog";

export default function AdminSettingsRoles() {
  const model = useRolesModel();

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col">
      <RolesToolbar
        search={model.search}
        onSearchChange={model.setSearch}
        onNewRole={() => {
          model.setEditing(null);
          model.setDialogOpen(true);
        }}
      />

      <div className="-mx-3 flex min-h-0 flex-1 flex-col md:mx-0">
        {model.isLoading ? (
          <RoleListSkeleton />
        ) : (
          <RoleList
            roles={model.roles}
            onEdit={(role) => {
              model.setEditing(role);
              model.setDialogOpen(true);
            }}
            onDelete={model.deleteRole}
          />
        )}
      </div>

      <RoleDialog
        open={model.dialogOpen}
        editingRole={model.editing}
        groupedPermissions={model.groupedPermissions}
        onClose={() => {
          model.setDialogOpen(false);
          model.setEditing(null);
        }}
        onSaved={model.reload}
      />
    </div>
  );
}
